import React from "react";
import { connect } from "react-redux";
import logo from "../../static/images/logo.jpg";
import jaksonSolarLogo from "../../static/images/jaksonSolarLogo.png";
class SessionExpired extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className="mobile">
        <header>
          <div className="row" style={{ width: "100%" }}>
            <div className="col-lg-12 text-center">
              <img src={jaksonSolarLogo} className="header-logo" width="100" alt="" />
            </div>
          </div>
        </header>
        <section className={`main-section`}>
          <div className="container-fluid">
            <div className="row center">
              <div className="col-lg-12 text-center">
                <h1 className="error">Session Expired!</h1>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return { userName: state.auth.userName };
}

export default connect(mapStateToProps)(SessionExpired);
